// @flow

import {tailorComponentExamples as generatedTailorComponentExamples} from './examples';
import {BoxExamples} from './Box';
import {InlineExamples} from './Inline';

export type TailorComponentName = string;
export type TailorComponentExample = {|
  rendered: React.Node,
  source: string,
|};

// NOTE: These examples are copied via http://go/sail-next-tailor-docs-publisher

export type TailorComponentsToExamples = {|
  [component: TailorComponentName]: {
    [exampleName: string]: TailorComponentExample,
  },
|};

export const componentToExamples: TailorComponentsToExamples = {
  ...generatedTailorComponentExamples,
  Box: BoxExamples,
  Inline: InlineExamples,
};
